<article [ngClass]="valueType === 'image' ? 'info-box-image dead-center mb-4' : 'info-box'">
  @if (valueType !== 'image') {
    <span class="overline-list custom-color-tertiary mb-1">{{ isTranslatable ? (label | translate) : label }}</span>
  }

  @switch (valueType) {
    @case ('text') {
      <div class="color-light">
        {{ value }}
      </div>
    }
    @case ('currency') {
      <div class="text-xl color-light">
        <strong>{{ valueOrMax | currency:'EUR':'symbol' }}</strong>
      </div>
    }
  }

  @switch (valueType) {
    @case ('currency') {
      <div class="color-light">
        BCP {{ businessCardPrice | number:'1.2-2'}}
      </div>
    }
  }
</article>
